import { t } from 'i18next';
import { ReactComponent as TutorSVGLogo } from 'src/assets/images/tutor-overlay.svg';

type TutorLogoPropTypes = {
  withLogoText?: boolean;
};

function TutorLogo(props: TutorLogoPropTypes) {
  const { withLogoText = false } = props;

  return (
    <>
      <div className='flex justify-center items-center flex-shrink-0' aria-hidden>
        <TutorSVGLogo />
      </div>
      {withLogoText && (
        <h6 className='mx-space-4 text-main text-3xl uppercase font-bold' aria-label={t('AI_STUDY_TOOL')}>
          {t('AI_STUDY_TOOL')}
        </h6>
      )}
    </>
  );
}

export default TutorLogo;
